// extracted by mini-css-extract-plugin
export default {"container":"IconInput_container__MNvMS","pressed":"IconInput_pressed__K5IhI"};